var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#magic-wand_svg__clip0_7114_140712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.257 40.424l-11.21-9.951 4.72-14.239-14.238 4.72-9.952-11.21-2.99 14.711-14.71 2.99 11.21 9.95-2.753 8.34-1.967 5.9 5.9-1.967 8.339-2.754 9.951 11.21 2.99-14.71 14.71-2.99z",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.117 39.885l10.747-2.882 1.44 5.374-10.746 2.881-1.44-5.373zM87.825 24.77l10.747-2.882 1.441 5.373-10.747 2.882-1.44-5.374zM54.754 65.46l2.881-10.747 5.374 1.44L60.127 66.9l-5.373-1.44zM70.03 10.742L72.912-.005l5.373 1.44-2.881 10.748-5.374-1.441zM44.432 8.363l7.865 7.865-3.933 3.933-7.865-7.865 3.933-3.933zM83.765 47.688l7.865 7.865-3.933 3.933-7.865-7.865 3.933-3.933zM54.267 49.667L14.933 89.001 11 85.068l39.333-39.334-1.966 5.9 5.9-1.967z",
    fill: "#E1EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2 45.734l-3.934 3.933-5.9 1.967 1.967-5.9 3.933-3.933 3.934 3.933z",
    fill: "#D5E0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "magic-wand_svg__clip0_7114_140712"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/magic-wand.3bc4583391f04846b37fb0c1b8f893d7.svg";
export { SvgMagicWand as ReactComponent };